import React, { PureComponent } from "react";
import Unsplash, { toJson } from "unsplash-js";
import Modal from "@material-ui/core/Modal";
import styles from "./style.module.css";
import GridList from "@material-ui/core/GridList";
import GridListTile from "@material-ui/core/GridListTile";
import Cropper from "react-easy-crop";
import firebase from "firebase";
import { is_empty } from "../../../utils/validations";
import { generateRandomString } from "../../../utils/Utils";
import ImageIcon from "@material-ui/icons/Image";

import { StyledDemo } from "./photoZoom";
import {
  preProcessB64ImageForS3Upload,
  uploadImageToExlyBucket,
} from "features/Common/modules/ExlyImage/utils/ExlyImage.utils";
import { logError } from "utils/error";
import {
  file_format_keys,
  file_mime_types,
} from "features/Common/modules/File/File.constants";
import ExlyImage from "features/Common/modules/ExlyImage/ExlyImage";
import { FIREBASE_CONFIG } from "features/Firebase/constants/Firebase.constants";
import { ZOOM_DEFAULT } from "./constants";

if (!firebase.apps.length) {
  firebase.initializeApp(FIREBASE_CONFIG);
} else {
  firebase.app();
}

const storage = firebase.storage();

const unsplash = new Unsplash({
  accessKey: process.env.REACT_APP_UNSPLASH_ACCESSS_KEY,
  secret: process.env.REACT_APP_UNSPLASH_SECRET,
});

class RightPanel extends PureComponent {
  constructor(props) {
    super(props);
    this.timeout = 0;
  }

  state = {
    src: "",
    crop: { x: 0, y: 0 },
    zoom: ZOOM_DEFAULT.DEFAULT_ZOOM,
    aspect: this.props.aspect || ZOOM_DEFAULT.ASPECT_RATIO,
    croppedAreaPixels: null,
    showModal: false,
    showOriginal: true,
    modalState: false,
    imageWidth: 100,
    imageHeight: 100,
    borderRadius: "50%",
    minWidth: 160,
    minHeight: 100,
    croppedFile: "",
    blobFile: undefined,
    query: "",
    pics: [],
    isFetchingImages: false,
    isUploading: false,
  };

  componentDidMount() {
    document.querySelector("#stock_search").onkeypress = (event) => {
      if (event.keyCode === 13) {
        event.preventDefault();
      }
    };

    this.searchPhotos(this.props.query);

    this.setState({
      src: this.props.image,
      original: this.props.image,
      zoom: Math.max(
        ZOOM_DEFAULT.INITIAL_ZOOM,
        this.props.zoom || ZOOM_DEFAULT.INITIAL_ZOOM
      ), // default cropped area 70%
      crop: { x: 0, y: 0 },
      aspect: this.props.crop?.aspect ?? ZOOM_DEFAULT.ASPECT_RATIO,
      showModal: false,
      showOriginal: true,
      modalState: false,
      imageWidth: this.props.width,
      imageHeight: this.props.height,
      borderRadius: this.props.radius,
      minWidth: this.props.minWidth,
      minHeight: this.props.minHeight,
      query: "",
    });

    if (this.props.existingimage) {
      this.setState({
        src: this.props.imageexits,
        showModal: true,
        modalState: true,
      });
    }
  }

  onFileSelected = (e) => {
    if (this.props.checkImageSizeExceeds(e)) return;
    this.setState({
      showModal: true,
      modalState: true,
    });
  };

  onSelectFile = (e) => {
    if (e.target.files && e.target.files.length > 0) {
      this.setState({ file: e.target.files[0] });
      const reader = new FileReader();
      reader.addEventListener("load", () =>
        this.setState({
          src: reader.result,
          // reset when new file selected
          crop: { x: 0, y: 0 },
          zoom: ZOOM_DEFAULT.INITIAL_ZOOM,
          croppedAreaPixels: null,
        })
      );
      reader.readAsDataURL(e.target.files[0]);
    }
  };

  onCropComplete = (_, croppedAreaPixels) => {
    this.setState({ croppedAreaPixels });
  };

  closeModal = async () => {
    const { src, croppedAreaPixels } = this.state;

    if (!src || !croppedAreaPixels) return;

    try {
      const croppedImage = await this.getCroppedImg(src, croppedAreaPixels);
      const imageData = croppedImage;

      this.setState({ croppedImageUrl: croppedImage });
      this.setState({ isUploading: true });

      if (this.props.uploadViaOptimization) {
        /**
         * Added default values for fileName and type when selecting from splash.
         * PNG has been set has default type as in cropping image a
         * new image is change to png format.
         */
        const fileName = this.state.file?.name || `${Date.now()}.png`;
        const fileType =
          this.state.file?.type || file_mime_types[file_format_keys.png][0];
        let processedFile = preProcessB64ImageForS3Upload(imageData);
        if (this.state.blobFile) {
          processedFile = this.state.blobFile;
        }
        uploadImageToExlyBucket({
          fileName: fileName,
          fileType: fileType,
          file: processedFile,
          sectionName: this.props.sectionName,
        }).then((publicImageUrl) => {
          this.setState({
            showModal: false,
            showOriginal: false,
            modalState: false,
            isUploading: false,
          });
          this.props.getUrl(publicImageUrl);
          this.setState({ croppedImageUrl: publicImageUrl });
        });
      } else {
        let randomText = generateRandomString();
        let filename = imageData.toString().substring(9, 18) + randomText;
        let storageRef = storage.ref("/exly");
        let fileRef = storageRef
          .child(filename)
          .putString(imageData, "data_url");
        fileRef.on(
          "state_changed",
          function () {
            /**
           * TODO: figure out what is the purpose of this argument
           * OLD function definition that wasn't doing anything
           * ```
              function (snapshot) {
                let progress = (snapshot.bytesTransferred / snapshot.totalBytes) * 100;
              }
           * ```
           */
          },
          function (error) {
            logError({
              error: error?.body?.message,
              occuredAt:
                "upload images to firebase in src/ui/widgets/photoUploader/RightPanel.js",
              when: "Error while uploading image to firebase",
            });
          },
          () => {
            fileRef.snapshot.ref.getDownloadURL().then((downloadURL) => {
              this.setState({
                showModal: false,
                showOriginal: false,
                modalState: false,
                isUploading: false,
              });
              this.props.getUrl(downloadURL);
              this.setState({ croppedImageUrl: downloadURL });
            });
          }
        );
      }
    } catch (error) {
      console.error("Error cropping image:", error);
      logError({
        error: error.message,
        occuredAt: "closeModal in src/ui/widgets/photoUploader/RightPanel.js",
        when: "Error while cropping image",
      });
    }
  };

  closeModalWithoutSaving = () => {
    this.setState({
      showModal: false,
      src: this.props.original,
      showOriginal: true,
      crop: this.props.crop,
      modalState: false,
    });
  };

  getCroppedImg = (imageSrc, crop) => {
    return new Promise((resolve, reject) => {
      if (!imageSrc) {
        reject(new Error("Image source is required"));
        return;
      }

      const image = new Image();
      image.src = imageSrc;
      image.crossOrigin = "anonymous";

      image.onerror = () => {
        reject(new Error("Failed to load image"));
      };

      image.onload = () => {
        const canvas = document.createElement("canvas");
        const ctx = canvas.getContext("2d");

        canvas.width = crop.width;
        canvas.height = crop.height;

        ctx.drawImage(
          image,
          crop.x,
          crop.y,
          crop.width,
          crop.height,
          0,
          0,
          crop.width,
          crop.height
        );

        canvas.toBlob((blob) => {
          this.setState({
            croppedFile: canvas.toDataURL("image/png"),
            blobFile: blob,
          });
          resolve(canvas.toDataURL("image/png"));
        }, "image/png");
      };
    });
  };

  searchPhotos = async (searchText) => {
    try {
      if (is_empty(searchText)) {
        searchText = is_empty(this.props.query) ? "Random" : this.props.query;
      }
      this.setState({ isFetchingImages: true });

      if (this.timeout) clearTimeout(this.timeout);
      this.timeout = setTimeout(() => {
        unsplash.search
          .photos(searchText, 1, 20, { orientation: "landscape" })
          .then(toJson)
          .then((json) => {
            this.setState({ pics: json.results });
            this.setState({ isFetchingImages: false });
          })
          .catch((err) => {
            console.error(
              "error occured while calling unsplash.search in RightPanel",
              err
            );
          });
      }, 200);
    } catch (err) {
      console.error("searchPhotos err", err);
    }
  };

  readChildData = (e) => {
    const croppedImageUrl = e.urls.regular;

    this.setState({
      src: croppedImageUrl,
      showModal: true,
      modalState: true,

      // reset crop on changing image
      crop: { x: 0, y: 0 },
      zoom: ZOOM_DEFAULT.INITIAL_ZOOM,
      croppedAreaPixels: null,
    });
  };

  handleZoomIn = () => {
    this.setState((prev) => ({
      zoom: Math.min(
        ZOOM_DEFAULT.MAX_ZOOM,
        Number((prev.zoom + ZOOM_DEFAULT.ZOOM_STEP).toFixed(2))
      ),
    }));
  };

  handleZoomOut = () => {
    this.setState((prev) => ({
      zoom: Math.max(
        ZOOM_DEFAULT.MIN_ZOOM,
        Number((prev.zoom - ZOOM_DEFAULT.ZOOM_STEP).toFixed(2))
      ),
    }));
  };

  handleRest = () => {
    this.setState({
      crop: { x: 0, y: 0 },
      zoom: ZOOM_DEFAULT.DEFAULT_ZOOM,
      croppedAreaPixels: null,
    });
  };

  render() {
    const { src } = this.state;

    if (this.props.uploadViaOptimization && !this.props.sectionName) {
      throw new Error(
        "sectionName is empty. sectionName is needed for the RightPanel to work when uploadViaOptimization is true"
      );
    }

    return (
      <div className={styles.drawerWidth}>
        <p className={styles.titleText}>Select / Upload Image</p>

        <div className={styles.upload_device_background}>
          <ImageIcon style={{ color: "#6c5dd3", fontSize: 54 }} />

          <span className={styles.button}>Upload from Device</span>

          <input
            type="file"
            accept="image/x-png,image/jpg,image/jpeg"
            onChange={this.onSelectFile}
            onChangeCapture={this.onFileSelected}
            alt="image crop"
            style={{
              height: "250px",
              cursor: "pointer !important",
              opacity: 0,
              position: "absolute",
              top: 0,
              left: 0,
              width: "100%",
            }}
          />
        </div>

        <br />
        <div
          className={styles.horizontalContainer}
          style={{ alignItems: "center" }}
        >
          &bull;&nbsp;
          <div style={{ fontSize: "16px" }}> OR </div>
          &nbsp;&bull;
        </div>
        <br />

        {this.props.from === "congratulatepopup" && this.state.showModal ? (
          <Modal open={this.state.modalState} disableEnforceFocus>
            <StyledDemo
              image={this.props.image}
              src={src}
              isUploading={this.state.isUploading}
              closeModalWithoutSaving={this.closeModalWithoutSaving}
              closeModal={this.closeModal}
            />
          </Modal>
        ) : (
          this.state.showModal && (
            <Modal open={this.state.modalState} disableEnforceFocus>
              <div className="alert_modal modal_overflow !tw-p-0">
                <h1 className="tw-text-lg tw-font-bold tw-px-5 tw-pt-3">
                  Edit image
                </h1>

                <hr className="tw-border-0 tw-h-[2px] tw-bg-[#E7E6E4] tw-my-3" />

                <div className="tw-w-full tw-px-5 tw-py-3 tw-gap-0">
                  <div className="tw-relative tw-w-full tw-h-[360px] tw-rounded-lg tw-overflow-hidden tw-bg-black">
                    {src && (
                      <Cropper
                        image={src}
                        crop={this.state.crop}
                        zoom={this.state.zoom}
                        minZoom={ZOOM_DEFAULT.MIN_ZOOM}
                        maxZoom={ZOOM_DEFAULT.MAX_ZOOM}
                        aspect={this.state.aspect}
                        cropShape="rect"
                        showGrid={false}
                        onCropChange={(crop) => this.setState({ crop })}
                        onZoomChange={(zoom) => this.setState({ zoom })}
                        onCropComplete={this.onCropComplete}
                      />
                    )}
                    {!src && (
                      <div className="tw-flex tw-items-center tw-justify-center tw-h-full tw-text-white">
                        <div className="tw-text-center">
                          <div className="tw-text-lg tw-font-semibold">
                            No image selected
                          </div>
                          <div className="tw-text-sm tw-mt-2">
                            Please select an image to crop
                          </div>
                        </div>
                      </div>
                    )}
                  </div>

                  {/* Zoom Slider and reset button */}
                  {src && (
                    <div className="tw-flex tw-items-center tw-justify-between tw-mt-2 tw-gap-4">
                      {/* Left: Zoom controls (60%) */}
                      <div className="tw-flex tw-items-center tw-justify-start tw-align-middle tw-gap-5 tw-w-[60%]">
                        <span className="tw-text-sm tw-font-semibold tw-text-black">
                          Zoom
                        </span>

                        <div className="tw-flex tw-items-center tw-gap-2">
                          <button
                            type="button"
                            onClick={this.handleZoomOut}
                            disabled={this.state.zoom <= ZOOM_DEFAULT.MIN_ZOOM}
                            className="tw-text-base -tw-mt-1 tw-font-semibold tw-bg-transparent tw-border-none tw-cursor-pointer"
                          >
                            −
                          </button>

                          <input
                            type="range"
                            min={ZOOM_DEFAULT.MIN_ZOOM}
                            max={ZOOM_DEFAULT.MAX_ZOOM}
                            step={ZOOM_DEFAULT.ZOOM_STEP}
                            value={this.state.zoom}
                            onChange={(e) =>
                              this.setState({ zoom: Number(e.target.value) })
                            }
                            className="tw-w-full tw-h-[1px] tw-bg-black/20 tw-outline-none tw-cursor-pointer tw-appearance-none
                              [&::-webkit-slider-thumb]:tw-appearance-none
                              [&::-webkit-slider-thumb]:tw-w-[10px]
                              [&::-webkit-slider-thumb]:tw-h-[10px]
                              [&::-webkit-slider-thumb]:tw-bg-black
                              [&::-webkit-slider-thumb]:tw-rounded-full
                              [&::-webkit-slider-thumb]:tw-cursor-pointer
                              [&::-moz-range-thumb]:tw-w-[10px]
                              [&::-moz-range-thumb]:tw-h-[10px]
                             [&::-moz-range-thumb]:tw-bg-black
                              [&::-moz-range-thumb]:tw-rounded-full
                              [&::-moz-range-thumb]:tw-border-0
                              [&::-moz-range-thumb]:tw-cursor-pointer
                              [&::-moz-range-track]:tw-h-[1px]
                             [&::-moz-range-track]:tw-bg-black"
                          />

                          <button
                            type="button"
                            onClick={this.handleZoomIn}
                            disabled={this.state.zoom >= ZOOM_DEFAULT.MAX_ZOOM}
                            className="tw-text-base -tw-mt-1 tw-font-semibold tw-bg-transparent tw-border-none tw-cursor-pointer"
                          >
                            +
                          </button>
                        </div>
                      </div>

                      {/* Right: Reset button (40%) */}
                      <button
                        onClick={this.handleRest}
                        className="tw-text-sm tw-font-semibold tw-text-[#6c5dd3] tw-border-none tw-bg-white tw-w-[40%] tw-text-right"
                      >
                        Reset
                      </button>
                    </div>
                  )}
                </div>

                <hr className="tw-border-0 tw-h-[2px] tw-bg-[#E7E6E4] tw-my-3" />

                <div className="tw-flex tw-justify-between tw-text-center tw-content-center tw-px-5 tw-pb-5">
                  {this.state.isUploading ? null : (
                    <div
                      onClick={this.closeModalWithoutSaving}
                      className="tw-cursor-pointer tw-text-base tw-font-semibold tw-text-[#6c5dd3] tw-py-[7px]"
                    >
                      Cancel
                    </div>
                  )}

                  {this.state.isUploading ? (
                    <div
                      className={`${styles.cropText} ${styles.horizontalContainer}`}
                    >
                      <span>Uploading</span>
                      <div className={styles.loader}> </div>
                    </div>
                  ) : (
                    <div
                      onClick={this.closeModal}
                      className="tw-bg-[#6c5dd3] tw-py-[7px] tw-px-[20px] tw-rounded-[6px] tw-text-white tw-text-[16px] tw-font-semibold tw-cursor-pointer"
                    >
                      <span>Save</span>
                    </div>
                  )}
                </div>
              </div>
            </Modal>
          )
        )}

        <form autoComplete="off" className={styles.headerText}>
          <input
            type="text"
            id="stock_search"
            name="query"
            className={styles.searchInput}
            placeholder={`Search for stock images`}
            value={this.state.query}
            onChange={(e) => {
              this.searchPhotos(e.target.value);
              this.setState({ query: e.target.value });
            }}
          />
        </form>

        <span className={styles.credit}>
          <b>Results from</b> Unsplash
        </span>

        {this.state.isFetchingImages && (
          <div>
            {" "}
            <h3>Loading...</h3>
          </div>
        )}

        {!this.state.isFetchingImages &&
          (is_empty(this.state.pics) ? (
            <div>
              <br />
              <h5>Search for relevant keywords for suggestions</h5>
            </div>
          ) : (
            <GridList cols={2}>
              {this.state.pics.map((pic) => (
                <GridListTile
                  key={pic.id}
                  onClick={() => this.readChildData(pic)}
                >
                  <ExlyImage
                    className={styles.cardImage}
                    alt={pic.alt_description}
                    src={pic.urls.regular}
                    width="200px"
                    height="100%"
                    crossOrigin="Anonymous"
                  />
                </GridListTile>
              ))}
            </GridList>
          ))}
      </div>
    );
  }
}

export default RightPanel;

RightPanel.defaultProps = {
  checkImageSizeExceeds: () => {},
};
